
import makerjs from "makerjs";
function C30(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       w = W * 1 * myZoom,       
       h = H * 1 * myZoom,
     l=w*2,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       /**
        * 已知拱高 弦长 求半径 h为拱高，l为弦长
        * r=(h/2)+(l*l)/(8*h)
        * 
        */
       a=h/2,b=(l*l)/(8*h),
       r=a+b,
       x0=0,y0=0,x1=0,y1=h,x2=w,y2=0,glassH = h, glassW = w;
console.log("r===,h,l,a,b",r,h,l,a,b);
   if (w !== 0) {
       var TxtW = W;
   }if (h !== 0) {
    var TxtH = H;
} 
   var drawAbnormalShapeC30 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0,y0], [x1,y1]),
        "ArcLine": new makerjs.paths.Arc([x1,y1],[x2,y2],r,false,true),
        "BottomLine": new makerjs.paths.Line([x2,y2],[x0,y0]),
       }
   };
   var drawAbnormalShapeC30MarkW = {
       paths: {
        "Line": new makerjs.paths.Line([x0,y0-markShift], [x2,y2-markShift]),
        "LeftLine": new makerjs.paths.Line([x0,y0-2*markShift], [x0,y0]),
        "RithgLine": new makerjs.paths.Line([x2,y2-2*markShift], [x2,y2]),
       }
   };
   var drawAbnormalShapeC30MarkH = {
       paths: {
        "Line": new makerjs.paths.Line([x0-markShift, y0], [x1-markShift, y1]),
        "LineUp": new makerjs.paths.Line([x1-2*markShift, y1], [x1, y1]),
        "LineDn": new makerjs.paths.Line([x0-2*markShift, y0], [x0, y0]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeC30MarkW, TxtW, [x0,y0-2*markShift], [x2,y2-2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC30MarkH, TxtH, [x0-3*markShift, y0], [x1-3*markShift, y1]);//长度文字  
   
  plate={
    models: {
      drawAbnormalShapeC30: drawAbnormalShapeC30,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC30: drawAbnormalShapeC30,
        drawAbnormalShapeC30MarkW: drawAbnormalShapeC30MarkW,
        drawAbnormalShapeC30MarkH: drawAbnormalShapeC30MarkH,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C30;